import { Box, Typography } from '@mui/material';

import SectionTitle from './SectionTitle';

const contents = [
  'Giờ thăm',
  'Giờ thăm hỏi chung là 8h - 9h tối. Vui lòng xác nhận với đơn vị điều dưỡng của bạn nếu bạn ở các phòng chăm sóc đặc biệt',
];

const contents2 = [
  'Dịch vụ dinh dưỡng và thực phẩm',
  'Nhân viên của Dịch vụ Dinh dưỡng và Thực phẩm gửi bạn thực đơn cho ngày hôm sau cùng với khay ăn cá nhân. Thực đơn này tuân theo chế độ ăn do bác sĩ của bạn quy định và cung ',
  'cấp nhiều loại thực phẩm ngon, tốt cho sức khỏe. Chỉ cần khoanh tròn các lựa chọn của bạn và đặt thực đơn đã hoàn thành lên khay.',

  'Nhân viên sẽ kiểm tra các lựa chọn của bạn để đảm bảo rằng họ đồng ý với kế hoạch ăn uống do bác sĩ của bạn quy định, và sẽ có sẵn để thảo luận về thực đơn của bạn và trả lời bất kỳ ',
  'câu hỏi nào. Nếu bạn cần hỗ trợ thêm, nhân viên y tá trong đơn vị của bạn sẽ rất vui lòng liên hệ với Cục Dịch vụ Thực phẩm và Dinh dưỡng.',

  'Đôi khi, một số xét nghiệm y tế nhất định có thể được lên lịch trong giờ ăn thường xuyên của bạn, hoặc một thủ tục phải được thực hiện khi bụng đói. Điều này có thể làm chậm bữa ăn ',
  'của bạn. Tuy nhiên, ngay khi bạn có thể ăn, nhân viên điều dưỡng sẽ chuẩn bị bữa ăn cho bạn',

  'Nhân viên Dịch vụ Dinh dưỡng và Thực phẩm bao gồm các chuyên gia dinh dưỡng lâm sàng được đào tạo đặc biệt về khoa học dinh dưỡng, duy trì sức khỏe và giáo dục bệnh nhân. Các ',
  'chuyên gia dinh dưỡng của chúng tôi cung cấp hỗ trợ bổ sung dinh dưỡng cho những bệnh nhân có nhu cầu. Chúng tôi cũng sẵn sàng hướng dẫn cho bệnh nhân về kế hoạch ăn uống ',
  'đặc biệt và hạn chế ăn uống. Nếu bạn muốn tìm hiểu thêm về chế độ ăn uống của mình, hãy yêu cầu bác sĩ hoặc y tá của bạn liên hệ với chuyên gia dinh dưỡng.',

  'Nếu có bất kỳ góp ý nào, vui lòng cho chúng tôi biết bằng cách gọi Đường dây Trợ giúp Dịch vụ Thực phẩm Bệnh nhân theo số 0000-0000',
];

const contents3 = [
  'Vật dụng cá nhân',
  'Không có điều khoản nào cho việc có trách nghiệm bảo quản đồ đạc của bạn trong khi bạn ở trong bệnh viện. Mọi vật dụng cá nhân sẽ là trách nhiệm của bệnh nhân/gia đình. Tất cả đồ ',
  'đạc (bao gồm kính, máy trợ thính, răng giả, v.v.) phải được lấy ra khỏi phòng bệnh nhân nếu bệnh nhân được chuyển đến khu vực phẫu thuật hoặc phòng chăm sóc đặc biệt. Nếu bạn cần ',
  'gửi thứ đồ trong kho bệnh viện, vui lòng gọi cho phòng nậhp viện theo số  0000-0000',
];

const contents4 = [
  'Thủ tục xuất viện',
  'Khi bác sĩ cho bạn xuất viện và bạn đã chuẩn bị sẵn sàng, chúng tôi sẽ hỗ trợ bạn ra ngoài bằng xe lắn',
  'Trước khi đi, đừng quên kiểm tra kỹ phòng của bạn xem có đồ đạc cá nhân nào không bào gồm cả những đồ vật có giá trị của bạn được gửi tại kho của bệnh viện. Thời gian trả phòng ',
  'bệnh viện là 11 giờ sáng.',
];

const TwiceContents = () => {
  return (
    <>
      <SectionTitle title="Khi bạn ở đây" />

      <Box
        sx={{
          width: '98%',
          margin: '48px auto 24px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '15px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }

          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '15px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
            </Typography>
          );
        })}
      </Box>

      <Box
        sx={{
          width: '98%',
          margin: '48px auto 24px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents2.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '15px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }

          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '15px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
                marginBottom:
                  i === 2 || i === 4 || i === 6 || i === 9 ? '20px' : '',
              }}
            >
              {v}
            </Typography>
          );
        })}
      </Box>

      <Box
        sx={{
          width: '98%',
          margin: '48px auto 24px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents3.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '15px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }

          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '15px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
            </Typography>
          );
        })}
      </Box>

      <SectionTitle title="Xuất viện" />

      <Box
        sx={{
          width: '98%',
          margin: '48px auto 24px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents4.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '15px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }

          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '15px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
            </Typography>
          );
        })}
      </Box>
    </>
  );
};

export default TwiceContents;
